<template>
    <div>
        <div>
            <CButton
                color="success"
                class="
                    button
                    m-2
                    shadow
                "
                :title="$t('Bulk edit')"
                @click="
                    modals.mappingParameters.show = true
                    loadBulkString()
                "
            >
                <span class="button__icon">
                    <CIcon :content="$options.icons.cilPlus"/>
                </span>
                <span class="button__text">
                    {{
                        $t("Bulk edit")
                    }}
                </span>
            </CButton>
        </div>

        <CContainer>
            <!-- Modal bulk -->
            <CModal
                :title="$t('Bulk edit')"
                color="secondary"
                :show.sync="modals.mappingParameters.show"
                :closeOnBackdrop="false"
            >
                <CContainer fluid>
                    <CRow alignHorizontal="end">
                        <CButton color="transparent" @click="beautifyOptions()">
                            {{ $t("beautify") }}
                        </CButton>
                    </CRow>
                    <CTextarea
                        :placeholder="
                            $t(
                                'Add list of mapping parameters \nEj: first_name::Nombre'
                            )
                        "
                        height="500px"
                        :value.sync="
                            modals.mappingParameters.stringData
                        "
                        size="sm"
                    >
                    </CTextarea>
                </CContainer>
                <template #footer>
                    <!-- Button close modal -->
                    <CButton
                        color="secondary"
                        :title="$t('close')"
                        @click="
                            closeModal({
                                modalName:
                                    'mappingParameters',
                            })
                        "
                    >
                        {{ $t("close") }}
                    </CButton>
                    <!-- Button save modal -->
                    <CButton
                        color="secondary"
                        :title="$t('save')"
                        @click="
                            saveBulkString()
                        "
                    >
                        {{ $t("save") }}
                    </CButton>
                </template>
            </CModal>
        </CContainer>
    </div>
</template>

<script>
import { cilDataTransferDown, cilArrowThickFromRight, cilPlus } from "@coreui/icons";
import modalMixin from "~/mixins/modal.js";
import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";
export default {
    name: "ButtonBulkComponent",
    icons: {
        cilArrowThickFromRight,
        cilDataTransferDown,
        cilPlus
    },
    components: {},
    mixins: [modalMixin, tableMixin,baseMixin],
    data() {
        return {
            adapterFields: {
                items:[]
            },
            modals: {
                mappingParameters: {
                    show: false,
                    data: {
                    },
                    stringData:"",
                    dataSplit:"",
                },
            },
            valueComponent: null,
            optionsIsValid: null,
            isDisabled: null,

        };
    },
    computed: {},
    props: {
        value: {
            type: Array | Object,
            default: () => {
                return [];
            },
        },

        keyLeftValue: {
            type: String,
            default: "name",
        },
        keyRightValue: {
            type: String,
            default: "value",
        }
    },
    watch: {
        value(newValue) {
            this.adapterFields.items= newValue;
        },
        "adapterFields.items": {
            handler(newValue) {
                this.$emit("update:value", newValue);
                this.$emit("change", newValue);
            },
            deep: true,
        },
    },

    methods: {
        loadBulkString(){
            var mappingItems= this.adapterFields.items;
            var string="";
            var stringMap=[];


            if(mappingItems){
                for (const property in mappingItems) {
                    string= mappingItems[property][this.keyLeftValue].trim()+"::"+mappingItems[property][this.keyRightValue].trim();
                    stringMap.push(string);
                }
                if(stringMap.length > 1){
                    stringMap= stringMap.join("\n");
                }else{
                    stringMap= stringMap[0];
                }
            }

            this.modals.mappingParameters.stringData = stringMap;
        },
        saveBulkString(){
            var data= this.modals.mappingParameters.stringData;
            this.dataSplit= data.split("\n");
            var adapterValue=[];
            var mapValue={};
            var values;

            if(this.checkBulkFormat()){
                this.dataSplit.forEach( (value) => {
                    if(value != ""){
                        values= value.trim().split("::");
                        mapValue[this.keyLeftValue]= values[0];
                        mapValue[this.keyRightValue]= values[1];
                        mapValue.uuid= this.generateUUID();
                        adapterValue.push(mapValue);
                        mapValue={};
                    }
                });

                this.adapterFields.items=adapterValue;
                this.modals.mappingParameters.show = false;
            }
        },
        checkBulkFormat(){
            var check= true;
            var error={
                message : "Bad Format"
            };
            this.dataSplit.forEach( (value) => {
                if((value.match(/\:/g) || []).length != 2 || value.substr(value.length - 1) == ":"){
                    this.showMessageError(error);
                    check= false;
                }
            });
            return check;
        },
        beautifyOptions() {
            var beautifyValue= this.modals.mappingParameters.stringData;
            var dataSplit= beautifyValue.split("\n");
            dataSplit.forEach( (value, index) => {
                if((value.match(/\:/g) || []).length == 1 ){
                    value= value.replaceAll(":", "::");
                }
                dataSplit[index]= value.trim();
            });
            this.modals.mappingParameters.stringData= dataSplit.join("\n");
        },
        generateUUID() {
            function uuidv4() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
                    /[018]/g,
                    (c) =>
                        (
                            c ^
                            (crypto.getRandomValues(new Uint8Array(1))[0] &
                                (15 >> (c / 4)))
                        ).toString(16)
                );
            }
            return uuidv4();
        },
    },
    mounted() {
        if (this.value) {
            this.adapterFields.items = this.value;
        }
        this.loadBulkString();
    },
};
</script>

<style lang="scss" scoped>
</style>